import React, { useState } from 'react'
import { Link } from 'gatsby'
import Collapse from 'react-bootstrap/Collapse'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faSearch } from '@fortawesome/free-solid-svg-icons'
import researchLogo from '../../images/logo.png'


const SideMenu = ({featured, all, subjects}) => {
    const allContent = all;
    const featuredContent = featured;
     //states
    const [divisionSubmenuOpen, setDivisionSubmenuOpen] = useState(false);
    const [contentSubmenuOpen, setcontentSubmenuOpen] = useState(false);
    const [featuresSubmenuOpen, setFeaturesSubmenuOpen] = useState(false);
    const [librarySubmenuOpen, setLibrarySubmenuOpen] = useState(false);
    const [libraryDbSubmenuOpen, setLibraryDbSubmenuOpen] = useState(false);
    const [csuSubmenuOpen, setCsuSubmenuOpen] = useState(false);
    //

    if (typeof window !== "undefined"){
        return ( 
            <Navbar collapseOnSelect expand="lg" sticky="top" className="bootstrap-vertical-nav flex-column bg-white">
            <div id="sidebar-header" className="header-menu header">
                <Navbar.Toggle className="menu-toggle navbar-toggler pointer" aria-controls="researchMenu"><FontAwesomeIcon icon={faBars}/><span className="sr-only">Toggle menu</span></Navbar.Toggle>
                <a className="logo-link ease" href="/Division/Research/"><img src={researchLogo} alt="Research Division Logo. State of Nevada shape to the left of the words 'Research Division, Legislative Counsel Bureau, Connecting People to Policy'" className="logo-img img-fluid" /></a>
            </div>
            <Navbar.Collapse className="mt-1" id="researchMenu">
                <div className="nav flex-column">
                    <a href="#" onClick={()=> setDivisionSubmenuOpen(!divisionSubmenuOpen)} aria-controls="researchSubmenu" aria-expanded={divisionSubmenuOpen} className="nav-link dropdown-toggle">Our Division</a>
                    <Collapse in={divisionSubmenuOpen} className="submenu">
                        <div id="researchSubmenu">
                            <a href="/Division/Research/About/" className="nav-link second-level">About Us</a>
                            <a href="/Division/Research/About/Contact/" className="nav-link second-level">Contact Us</a>
                            <a href="#" onClick={()=> setLibrarySubmenuOpen(!librarySubmenuOpen)} aria-controls="librarySubmenu" aria-expanded={librarySubmenuOpen} className="nav-link second-level dropdown-toggle">Research Library</a>
                            <Collapse in={librarySubmenuOpen} className="submenu">
                                <div id="librarySubmenu">
                                    <a href="/Division/Research/Library/" className="nav-link third-level">Library Home</a>
                                    <a href="#" onClick={()=> setLibraryDbSubmenuOpen(!libraryDbSubmenuOpen)} aria-controls="libraryDatabases" aria-expanded={libraryDbSubmenuOpen} className="nav-link third-level dropdown-toggle"><FontAwesomeIcon icon={faSearch} className="mr-2"/>Searchable Databases</a>
                                    <Collapse in={libraryDbSubmenuOpen} className="submenu">
                                        <div id="libraryDatabases">
                                            <a href="/dbtw-wpd/SimpleSearch.htm" className="nav-link fourth-level">Legislative History</a>
                                            <a href="/dbtw-wpd/SearchCatalogBasic.htm" className="nav-link fourth-level">Library Catalog</a>
                                            <a href="/dbtw-wpd/LegSim.htm" className="nav-link fourth-level">Nevada Legislators</a>
                                            <a href="/dbtw-wpd/Veto.html" className="nav-link fourth-level">Vetoed Bills</a>
                                            <a href="/dbtw-wpd/Reports.html" className="nav-link fourth-level">Reports to the Legislature</a>
                                            <a href="/dbtw-wpd/SchoolSearch.htm" className="nav-link fourth-level">Schools and Legislative Districts</a>
                                        </div>
                                    </Collapse>
                                    <a href="/Division/Research/Library/LegHistory/Minutes/" className="nav-link third-level">Old Committees, Minutes, Exhibits</a>
                                    <a href="/Division/Research/About/Contact/" className="nav-link third-level">Contact the Library</a>
                                </div>
                            </Collapse>
                            <a href="#" onClick={()=> setCsuSubmenuOpen(!csuSubmenuOpen)} aria-controls="csuSubmenu" aria-expanded={csuSubmenuOpen} className="nav-link second-level dropdown-toggle">Constituent Services Unit</a>
                            <Collapse in={csuSubmenuOpen} className="submenu">
                                <div id="csuSubmenu">
                                    <a href="/Division/Research/About/CSU/" className="nav-link third-level">About CSU</a>
                                    <a href="/Division/Research/About/FAQ/" className="nav-link third-level">Frequently Asked Questions</a>
                                    <a href="/Division/Research/About/Contact/" className="nav-link third-level">Contact CSU</a>
                                </div>
                            </Collapse>
                        </div>
                    </Collapse>
                    <a href="#" onClick={()=> setcontentSubmenuOpen(!contentSubmenuOpen)} aria-controls="contentSubmenu" aria-expanded={contentSubmenuOpen} className="nav-link dropdown-toggle">Our Content</a>
                    <Collapse in={contentSubmenuOpen} className="submenu">
                        <div id="contentSubmenu">
                        <Link to={ featuredContent.url } className="second-level nav-link">Featured Research Content</Link>
                        <Link to={ allContent.url } className="second-level nav-link">All Research Content</Link>
                        <NavDropdown.Divider/>
                        {
                            subjects.map(({node}) => {
                                return (
                                    <Link to={node.url } className="second-level nav-link" key={node.uid}>
                                        <i className={node.data.subject_icon} aria-hidden="true"></i> {node.data.subject_name}
                                    </Link>
                                       
                                )
                            })
                        }
                        </div>
                    </Collapse>
                    <a href="#" onClick={()=> setFeaturesSubmenuOpen(!featuresSubmenuOpen)} aria-controls="featuresSubmenu" aria-expanded={featuresSubmenuOpen} className="nav-link dropdown-toggle">Our Features</a>
                    <Collapse in={featuresSubmenuOpen} className="submenu">
                        <div id="featuresSubmenu">
                        <a href="/Division/Research/LegInfo/" className="nav-link second-level">About Legislators</a>
                        <a href="/Division/Research/Districts/" className="nav-link second-level">About Districts</a>
                        <a href="/Division/Research/Districts/Reapp/2021/" className="nav-link second-level">Reapportionment and Redistricting</a>
                        </div>
                    </Collapse>
                </div>
            </Navbar.Collapse>
        </Navbar>
        )
     }
     else {
         return null;
     }  
  };

  export default SideMenu;